import { isNullOrUndefined } from "et3-type-guards";
import getApproveRejectStore from ".";

export const changeAlbumStatusInLocal = async (
  index: number,
  imageID: string,
  status: "Y" | "N" | "P"
) => {
  const albumPictureIndex = getApproveRejectStore()
    .approvalData.get()
    [index].albumPicture.findIndex((x) => {
      return `${x.id}` === `${imageID}`;
    });
  if (!isNullOrUndefined(albumPictureIndex) && albumPictureIndex > -1) {
    getApproveRejectStore().approvalData.get()[index].albumPicture[
      albumPictureIndex
    ].status = status;
  }
};
